import PropTypes from 'utils/prop-types';
import React, { Component } from 'react';

class Container extends Component {
  static propTypes = {
    ChildComponent: PropTypes.func.isRequired,
    configKey: PropTypes.string.isRequired,
    mappedPageConfig: PropTypes.shape({
      fixed: PropTypes.registeredCompositions,
      top: PropTypes.registeredCompositions,
      quick_action_items: PropTypes.shape({
        left: PropTypes.registeredCompositions,
        right: PropTypes.registeredCompositions,
      }).isRequired,
      left: PropTypes.registeredCompositions,
      right: PropTypes.registeredCompositions,
    }).isRequired,
    pageConfig: PropTypes.shape({
      data: PropTypes.string,
      fixed: PropTypes.compositionConfig,
      top: PropTypes.compositionConfig,
      quick_action_items: PropTypes.shape({
        left: PropTypes.compositionConfig,
        right: PropTypes.compositionConfig,
      }).isRequired,
      left: PropTypes.compositionConfig,
      right: PropTypes.compositionConfig,
    }).isRequired,
    setCurrentPageConfigKey: PropTypes.func.isRequired,
  };

  componentWillMount() {
    this.initialize(this.props);
  }

  componentWillReceiveProps(nextProps) {
    // Switching between different types of detail page should build a new Page component
    if (nextProps.configKey !== this.props.configKey) {
      this.initialize(nextProps);
    }
  }

  buildDetailsPageWithData = ({ ChildComponent, mappedPageConfig }) => {
    const { data } = mappedPageConfig;
    return data.hoc(ChildComponent);
  }

  initialize = (props) => {
    const {
      configKey,
      setCurrentPageConfigKey,
    } = props;
    this.DetailsPageWithData = this.buildDetailsPageWithData(props);
    setCurrentPageConfigKey(configKey);
  }

  render() {
    const { DetailsPageWithData } = this;

    const {
      ChildComponent,
      setCurrentPageConfigKey,
      ...rest
    } = this.props;

    if (DetailsPageWithData) {
      return (
        <DetailsPageWithData
          componentProps={{ ...rest }}
        />
      );
    }

    return null;
  }
}

export default Container;



// WEBPACK FOOTER //
// ./compositions/DetailsPage/Container/Component.js